/* eslint-disable import/order */
import '@/@iconify/icons-bundle'
import App from '@/App.vue'
import ability from '@/plugins/casl/ability'
import i18n from '@/plugins/i18n'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import { abilitiesPlugin } from '@casl/vue'
import '@/styles/styles.scss'
import 'unfonts.css'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'

// Create vue app
const app = createApp(App)

// Create pinia store
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Use plugins
app.use(vuetify)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true
})

// Provide router and ability to pinia store
pinia.use(({ store }) => {
  store.router = markRaw(router)
  store.ability = markRaw(ability)
  store.i18n = markRaw(i18n.global)
})

// Chunk of a previous build no longer available (tab opened before a deploy): reload once to get the current build
window.addEventListener('vite:preloadError', event => {
  const KEY = 'c2b:preload-error-reload'
  try {
    const last = Number(sessionStorage.getItem(KEY))
    if (last && Date.now() - last < 10_000) return // Already reloaded: let the error surface instead of looping
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    return // Storage unavailable: can't guard against a reload loop
  }
  event.preventDefault()
  window.location.reload()
})

// Mount vue app
app.mount('#app')
